require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-donates-usd-1-000-to-the-fort-harrison-veterans-center.json") })
        }
      }, "path---articles-financial-center-donates-usd-1-000-to-the-fort-harrison-veterans-center");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-donates-usd-1-000-to-the-fort-harrison-veterans-center!./.cache/json/articles-financial-center-donates-usd-1-000-to-the-fort-harrison-veterans-center.json
// module id = 1605
// module chunks = 231608221292675